import FinnPulsePlugin from './plugin';

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/ban-types
        pulse: Function;
    }
}

// eslint-disable-next-line @typescript-eslint/ban-types
function getPulseSdkReference(): Function | null {
    if (window.pulse) {
        return window.pulse;
    }
    return null;
}

function registerFinnPlugin(): void {
    const pulseSdk = getPulseSdkReference();
    if (pulseSdk) {
        pulseSdk('provide', 'finnpulse', FinnPulsePlugin);
    } else if (window.console) {
        window.console.warn('No Pulse SDK found, unable to register Finn Pulse SDK plugin');
    }
}

registerFinnPlugin();
